export default "__VITE_ASSET__DyhzTcqq__"